// src/api/brands.js
import { http } from "../lib/http";

/* ------------------------------ helpers ------------------------------ */

function normalizeLang(lang) {
  const s = String(lang || "").toUpperCase().trim();
  if (s === "EN" || s === "JP" || s === "ZH") return s;
  return "ZH";
}

function withLangParams(params = {}, lang) {
  return { ...(params || {}), lang: normalizeLang(lang) };
}

function toBrandForm({ brandID, brandName, brandLogo } = {}) {
  const fd = new FormData();
  if (brandID != null) fd.set("brandID", String(brandID));
  if (brandName != null) fd.set("brandName", String(brandName));
  if (brandLogo instanceof File) fd.set("brandLogo", brandLogo);
  return fd;
}

function normalizeBrandRow(row) {
  if (!row || typeof row !== "object") return row;
  const out = { ...row };

  if (!out.brandLogo && out.logo) out.brandLogo = out.logo;

  const optKeys = [
    "brandDescZH",
    "brandDescEN",
    "brandDescJP",
    "brandLink",
    "brandLogo",
  ];
  for (const k of optKeys) {
    if (out[k] === "") out[k] = null;
  }

  return out;
}

function normalizeBrandList(data) {
  if (!Array.isArray(data)) return data;
  return data.map(normalizeBrandRow);
}

/* -------------------------------- API -------------------------------- */

export const BrandsAPI = {
  /**
   * WP: GET /wp-json/api/brand/all
   */
  async list({ lang } = {}) {
    const res = await http.get(`/brand/all`, {
      params: withLangParams({}, lang),
    });
    return normalizeBrandList(res.data);
  },

  /**
   * WP: GET /wp-json/api/brand/:brandID
   */
  async read(brandID, { lang } = {}) {
    const res = await http.get(`/brand/${encodeURIComponent(String(brandID))}`, {
      params: withLangParams({}, lang),
    });
    return normalizeBrandRow(res.data);
  },

  async create({ brandID, brandName, brandLogo, lang } = {}) {
    const fd = toBrandForm({ brandID, brandName, brandLogo });
    const res = await http.post(`/brand`, fd, {
      params: withLangParams({}, lang),
    });
    return normalizeBrandRow(res.data);
  },

  async update(brandID, { brandName, brandLogo, lang } = {}) {
    const fd = toBrandForm({ brandName, brandLogo });
    const res = await http.put(
      `/brand/${encodeURIComponent(String(brandID))}`,
      fd,
      { params: withLangParams({}, lang) }
    );
    return res.data;
  },

  async remove(brandID, { lang } = {}) {
    const res = await http.delete(
      `/brand/${encodeURIComponent(String(brandID))}`,
      { params: withLangParams({}, lang) }
    );
    return res.data;
  },

  async bulkCreate(items = [], { lang } = {}) {
    const res = await http.post(`/brand/bulk`, items, {
      params: withLangParams({}, lang),
    });
    return res.data;
  },
};

export default BrandsAPI;
